<template>
  <div class="game-wrap">
    <div class="game-container">
      <div class="game-block">
        <template v-if="!isLoading">
          <iframe v-if="!activeGame" :src="game.url" style="width: 100%; height: 100%" allowfullscreen></iframe>
          <div class="active-game" v-else>
            <div class="text">У вас есть активная игра. Пожалуйста, закончите её сначала:</div>
            <game-block :game="activeGame" />
            <router-link :to="{ name: 'game', params: { game: activeGame.slug } }" class="promo-item-btn">
              Хорошо
            </router-link>
          </div>
        </template>
        <template v-else>
          <object class="preloader-logo-site" type="image/svg+xml" data="/images/mln-logo-preloader-site.svg"></object>
        </template>

        <a class="fullscreen-btn" @click="this.closeFullscreen" v-if="this.open">
          <img src="/images/no-fullscreen.png" alt="" />
        </a>
        <a class="fullscreen-btn" @click="this.openFullscreen" v-else-if="!activeGame && !isLoading">
          <img src="/images/fullscreen.png" alt="" />
        </a>
      </div>

      <game-sidebar v-if="isAuthenticated" />
      <game-sidebar-no-auth v-else />

      <div class="gmob">
        <div class="gmob-l">
          <a href="#" class="gmob-close"></a>
          <a href="#" class="gmob-refresh"></a>
          <div class="gmob-title"><span>Слот</span> {{ game.title }}</div>
        </div>
        <div class="gmob-r">
          <a href="#" class="gmob-open-t"></a>
          <a href="#" class="gmob-open-fav"></a>
          <a href="#" class="gmob-open-win"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { FETCH_GAME } from '@/store/actions.type'
import PlayLine from '@/components/PlayLine'
import TheHeader from '@/components/TheHeader'
import { useI18n } from 'vue-i18n'
import GameSidebar from '@/components/game/GameSidebar'
import GameSidebarNoAuth from '@/components/game/GameSidebarNoAuth'
import GameBlock from '@/components/GameBlock.vue'

export default {
  name: 'Game',
  components: { GameBlock, GameSidebar, GameSidebarNoAuth, TheHeader, PlayLine },
  data() {
    return {
      isLoading: false,
      open: false,
      activeGame: null,
    }
  },
  setup() {
    const { t, locale } = useI18n()
    return { t, locale }
  },
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: 'demo', params: { game: this.$route.params.game } })
    } else {
      this.$router.push({ name: 'game', params: { game: this.$route.params.game } })

      this.$watch(
        () => this.$route.params,
        (toParams, oldParams) => {
          if (toParams.game !== oldParams.game) {
            this.loadGame(toParams.game, this.isDemo)
          }
        }
      )
    }
  },
  mounted() {
    this.loadGame(this.gameSlug, !this.isAuthenticated)
  },
  methods: {
    openFullscreen() {
      document.body.classList.add('iframe-overflow-hidden')
      this.open = true
    },
    closeFullscreen() {
      document.body.classList.remove('iframe-overflow-hidden')
      this.open = false
    },
    handleActiveGame(slug) {
      this.activeGame = this.gameBySlug(slug)
    },
    loadGame(slug, isDemo) {
      this.activeGame = null
      this.isLoading = true
      this.$store.dispatch(FETCH_GAME, { slug: slug, isDemo: isDemo }).then(data => {
        this.isLoading = false
        if (data.type === 'redirect') {
          this.handleActiveGame(data.slug)
        }
      })
    },
  },
  computed: {
    ...mapGetters(['game', 'isAuthenticated', 'gameBySlug']),
    ...mapState({
      errors: state => state.auth.errors,
    }),

    gameSlug: function () {
      return this.$route.params.game
    },
    isDemo: function () {
      return this.$route.name === 'demo'
    },
  },
}
</script>
